// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

import axios from 'axios';
import request from '@/utils/request';
var LOCAL_PRINTER_BASE = 'http://localhost:8080';
var LOCAL_PRINTER_DEVICE_ID = 1004;
export function orderListApi(params) {
  return request({
    url: '/admin/store/order/list',
    method: 'get',
    params: params
  });
}
export function afterSaleList(params) {
  return request({
    url: '/admin/afterSale/list',
    method: 'get',
    params: params
  });
}
/**
 * 订单 列表 获取各状态数量
 * @param params
 */
export function orderStatusNumApi(params) {
  return request({
    url: '/admin/store/order/status/num',
    method: 'get',
    params: params
  });
}

/**
 * 订单 列表 数据统计
 * @param params
 */
export function orderListDataApi(params) {
  return request({
    url: '/admin/store/order/list/data',
    method: 'get',
    params: params
  });
}
/**
 * 订单 删除
 * @param params
 */
export function orderDeleteApi(params) {
  return request({
    url: '/admin/store/order/delete',
    method: 'get',
    params: params
  });
}

/**
 * 订单 编辑
 * @param prams
 */
export function orderUpdateApi(data, params) {
  return request({
    url: '/admin/store/order/update',
    method: 'post',
    data: data,
    params: params
  });
}

/**
 * 订单 记录
 * @param prams
 */
export function orderLogApi(params) {
  return request({
    url: '/admin/store/order/status/list',
    method: 'get',
    params: params
  });
}

/**
 * 订单 详情
 * @param prams
 */
export function orderDetailApi(params) {
  return request({
    url: '/admin/store/order/info',
    method: 'get',
    params: params
  });
}

/**
 * 订单 备注
 * @param prams
 */
export function orderMarkApi(params) {
  return request({
    url: '/admin/store/order/mark',
    method: 'post',
    params: params
  });
}

/**
 * 订单 发货
 * @param prams
 */
export function orderSendApi(data) {
  return request({
    url: '/admin/store/order/send',
    method: 'post',
    data: data
  });
}

/**
 * 订单 拒绝退款
 * @param prams
 */
export function orderRefuseApi(params) {
  return request({
    url: '/admin/store/order/refund/refuse',
    method: 'get',
    params: params
  });
}

/**
 * 订单 立即退款
 * @param prams
 */
export function orderRefundApi(params) {
  return request({
    url: '/admin/store/order/refund',
    method: 'get',
    params: params
  });
}
export function orderRefundInfo(params) {
  return request({
    url: '/admin/store/order/refundInfo',
    method: 'get',
    params: params
  });
}
export function afterSaleRefundApi(params) {
  return request({
    url: '/admin/store/order/afterSaleRefund',
    method: 'get',
    params: params
  });
}
export function getProductData(params) {
  return request({
    url: '/admin/store/order/getProductData',
    method: 'get',
    params: params
  });
}

/**
 * 订单 拒绝退款
 * @param prams
 */
export function afterSaleRefuseApi(params) {
  return request({
    url: '/admin/store/order/refund/refuse',
    method: 'get',
    params: params
  });
}

/**
 * 订单 立即退款
 * @param prams
 */
export function agreeAfterSale(params) {
  return request({
    url: '/admin/afterSale/agreeAfterSale',
    method: 'get',
    params: params
  });
}
export function disagreeAfterSale(data) {
  return request({
    url: '/admin/afterSale/disagreeAfterSale',
    method: 'post',
    data: data
  });
}
export function receiveAfterSale(params) {
  return request({
    url: '/admin/afterSale/receiveAfterSale',
    method: 'get',
    params: params
  });
}

/**
 * 订单 核销订单
 * @param prams
 */
export function writeUpdateApi(vCode) {
  return request({
    url: "/admin/store/order/writeUpdate/".concat(vCode),
    method: 'get'
  });
}

/**
 * 订单 核销码查询待核销订单
 * @param prams
 */
export function writeConfirmApi(vCode) {
  return request({
    url: "/admin/store/order/writeConfirm/".concat(vCode),
    method: 'get'
  });
}

/**
 * 订单 统计 头部数据
 */
export function orderStatisticsApi() {
  return request({
    url: "/admin/store/order/statistics",
    method: 'get'
  });
}

/**
 * 核销订单 月列表数据
 */
export function statisticsDataApi(params) {
  return request({
    url: "/admin/store/order/statisticsData",
    method: 'get',
    params: params
  });
}

/**
 * 一键改价
 */
export function updatePriceApi(data) {
  return request({
    url: "admin/store/order/update/price",
    method: 'post',
    data: data
  });
}

/**
 *订单统计详情
 */
export function orderTimeApi(params) {
  return request({
    url: "/admin/store/order/time",
    method: 'get',
    params: params
  });
}

/**
 *面单默认配置信息
 */
export function sheetInfoApi() {
  return request({
    url: "/admin/store/order/sheet/info",
    method: 'get'
  });
}

/**
 *面单默认配置信息
 */
export function getLogisticsInfoApi(params) {
  return request({
    url: "/admin/store/order/getLogisticsInfo",
    method: 'get',
    params: params
  });
}

/**
 *视频号物流公司
 */
export function companyGetListApi() {
  return request({
    url: "/admin/pay/component/delivery/company/get/list",
    method: 'get'
  });
}

/**
 *视频号物流公司
 */
export function videoSendApi(data) {
  return request({
    url: "/admin/store/order/video/send",
    method: 'post',
    data: data
  });
}

/**
 * 打印小票（易联云，旧接口）
 */
export function orderPrint(id) {
  return request({
    url: "/admin/yly/print/".concat(id),
    method: 'get'
  });
}
function formatPrintMoney(val) {
  var num = parseFloat(val);
  return Number.isNaN(num) ? '0.00' : num.toFixed(2);
}

/**
 * 组装本地打印机销售单数据
 */
export function buildSalesOrderPrintPayload(order) {
  var productList = order.productList || [];
  var items = productList.map(function (val, index) {
    var info = val.info || {};
    var price = parseFloat(info.price) || 0;
    var quantity = info.buyQuantity || 0;
    return {
      seq: index + 1,
      name: info.productName || '',
      unitPrice: price.toFixed(2),
      quantity: String(quantity),
      amount: (price * quantity).toFixed(2)
    };
  });
  return {
    deviceId: LOCAL_PRINTER_DEVICE_ID,
    data: {
      brandName: '尹家鲜生鲜配送',
      documentTitle: '销售单',
      shopName: order.user && order.user.companyName || '',
      shopPhone: order.receiverPhone || order.user && order.user.mobile || '',
      shopAddress: order.receiverAddress || '',
      orderTime: order.createTime || '',
      orderNo: order.orderNo || '',
      items: items,
      itemCount: items.length,
      total: formatPrintMoney(order.payAmount),
      actualAmount: formatPrintMoney(order.payAmount),
      servicePhone: '19845369060'
    }
  };
}

/**
 * 调用本地打印程序打印销售单
 */
export function printSalesOrderLocal(order) {
  var payload = buildSalesOrderPrintPayload(order);
  if (!payload.data.items.length) {
    return Promise.reject(new Error('订单无商品明细，无法打印'));
  }
  return axios.post("".concat(LOCAL_PRINTER_BASE, "/printerDevice/printSalesOrder"), payload, {
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 10000
  }).then(function (res) {
    var body = res.data;
    if (body && body.errCode) {
      return Promise.reject(new Error(body.errMsg || '打印失败'));
    }
    return body;
  }).catch(function (error) {
    if (error.response && error.response.data && error.response.data.errMsg) {
      return Promise.reject(new Error(error.response.data.errMsg));
    }
    if (error.message === 'Network Error' || error.code === 'ECONNABORTED') {
      return Promise.reject(new Error('无法连接本地打印服务，请确认打印程序已启动'));
    }
    return Promise.reject(error);
  });
}
export function tagPrintStatus(orderId) {
  return request({
    url: "/admin/store/order/tagPrintStatus?orderId=" + orderId,
    method: 'get'
  });
}

/**
 * 订单 发货
 * @param prams
 */
export function updateExpressNum(data) {
  return request({
    url: '/admin/store/order/updateExpressNum',
    method: 'post',
    data: data
  });
}